/**
 * Класс по работе с куками
 */
export default class SwipeIcon {
    private readonly $holder: JQuery;
    private readonly $swipeIcon: JQuery;
    private readonly $swiperBlock: JQuery;
    private readonly HIDE_CLASS = 'hide';

    private selectors = {
        swipeIcon: '.js-icon-swipe',
        swiperBlock: '.js-icon-swipe-block',
    }

    constructor($holder: JQuery) {
        this.$holder = $holder;
        this.$swipeIcon = this.$holder.find(this.selectors.swipeIcon);
        this.$swiperBlock = this.$holder.find(this.selectors.swiperBlock);

        this.hideSwipeIcon = this.hideSwipeIcon.bind(this);
        this.initEvents();
    }

    /**
     * Инициализация событий
     */
    private initEvents(): void {
        this.$swiperBlock.on('scroll', this.hideSwipeIcon);
    }

    /**
     * Скрываем иконку свайпа
     * @param event
     * @private
     */
    private hideSwipeIcon(event): void {
        const scrollLeft = event.target.scrollLeft;

        if (scrollLeft > 0) {
            this.$swipeIcon.addClass(this.HIDE_CLASS);
        }
    }
}
